import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { SplashDialogService } from 'app/shared/dialogs/splash';


@Injectable({
    providedIn: 'root',
})
export class ErrorService {
    constructor(private splashSvc: SplashDialogService) {}

    // #region Handle Service Error Service Call

    // tslint:disable-next-line: no-any
    HandleServiceError(error: any): void {
        const self = this;

        let status: number | null = null;
        let msg = '';
        if (error instanceof HttpErrorResponse) {
            status = error.status;

            let body = error?.error ?? error;

            if (!!body?.errors && typeof body.errors === 'object') {
                // tslint:disable-next-line: no-any
                const errobj = body.errors as any;
                const errkeys = Object.keys(errobj);

                msg = errkeys
                    .map((k) => {
                        return errobj[k].toString();
                    })
                    .join('|');
            } else if (!!body?.error) {
                body = body.error;

                msg = body.ExceptionMessage || body.Message || body.message || body || 'An unknown error has occurred.';
            } else {
                msg = body.ExceptionMessage || body.Message || body.message || body || 'An unknown error has occurred.';
            }
        } else {
            if (!!error?.errors && typeof error.errors === 'object') {
                const errkeys = Object.keys(error.errors);

                msg = errkeys
                    .map((k) => {
                        return error.errors[k].toString();
                    })
                    .join('|');
            } else {
                let errorPacket = error?.message ?? error;
                if (typeof errorPacket !== 'object' && errorPacket != null && errorPacket !== '') {
                    try {
                        errorPacket = JSON.parse(errorPacket);
                    } catch {
                        errorPacket = errorPacket || 'An unknown error has occurred.';
                    }
                }
                msg =
                    errorPacket != null && errorPacket instanceof Object
                        ? errorPacket.ExceptionMessage || errorPacket.Message || error
                        : errorPacket || 'An unknown error has occurred.';
            }
        }

        // Something else, which should be snackbar displayed.
        if (msg.length > 300) {
            msg = msg.substr(0, 300) + '...';
        }

        this.splashSvc.CloseSplash();
        this.splashSvc.SnackbarError(msg);
    }

    // #endregion

    // #region Retrieve Service Error Service Call

    // tslint:disable-next-line: no-any
    RetrieveServiceError(error: any): ErrorInfo | null {
        let status: number | null = null;
        let msg: string | null = null;

        if (error instanceof HttpErrorResponse) {
            status = error.status;

            const body = error?.error ?? error;
            msg =
                body.ExceptionMessage || body.Message || body || (typeof body === 'string' ? body : 'An unknown error has occurred.');

            return { ErrorMessage: msg, ErrorObject: error } as ErrorInfo;
        } else {
            let errorPacket = error?.message ?? error;

            if (!errorPacket) {
                try {
                    errorPacket = JSON.parse(errorPacket);
                } catch {
                    errorPacket = errorPacket || 'An unknown error has occurred.';
                }
            }

            msg =
                errorPacket != null && errorPacket instanceof Object
                    ? errorPacket.ExceptionMessage || errorPacket.Message || error
                    : errorPacket || 'An unknown error has occurred.';

            const errObject = new HttpErrorResponse({
                error,
                status: 500, // General internal server error
                statusText: msg || undefined,
            });

            return { ErrorMessage: msg, ErrorObject: errObject } as ErrorInfo;
        }
    }

    // #endregion

    // #region Retrieve Service Error Message Service Call

    // tslint:disable-next-line: no-any
    RetrieveServiceErrorMessage(error: any): string | null {
        let status: number | null = null;
        let msg: string | null = null;

        if (error instanceof HttpErrorResponse) {
            status = error.status;

            const body = error?.error ?? error;
            msg =
                body.ExceptionMessage || body.Message || body || (typeof body === 'string' ? body : 'An unknown error has occurred.');

            return msg;
        } else {
            let errorPacket = error?.message ?? error;

            if (!errorPacket) {
                try {
                    errorPacket = JSON.parse(errorPacket);
                } catch {
                    errorPacket = errorPacket || 'An unknown error has occurred.';
                }
            }

            msg =
                errorPacket != null && errorPacket instanceof Object
                    ? errorPacket.ExceptionMessage || errorPacket.Message || error
                    : errorPacket || 'An unknown error has occurred.';

            return msg;
        }
    }

    // #endregion
}

// #region Custom Classes

export interface ErrorInfo {
    ErrorObject: HttpErrorResponse;
    ErrorMessage: string;
}

// #endregion
